import { PopUpStore } from "./PopUpStore";

export const popUpActions = {
    showPopUp: PopUpStore.actionShow,
    hidePopUp: PopUpStore.actionHide,
};